import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";
import React from "react";
import { getProfile } from "../services/profileService";

// const initUser = {
//   token: localStorage.getItem("token"),
//   user: JSON.parse(localStorage.getItem("user")),
// };
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(localStorage.getItem("token") ?? null);
  const detail = JSON.parse(localStorage.getItem("detail"));
  async function fetchData() {
    try {
      const user = await getProfile();
      if (user && authToken) {
            const {detail} = user ?? {}
            setUser({
            ...user,
            id: user?._id,
              onboardLastStep: detail?.step ?? null
            }); 
      } else {
        setUser(null);
      }
      return user;
    } catch (error) {
      console.log('error: ', error);
      return {}
    }
  }


  const login = async (token) => {
    localStorage.setItem("token", token);
    setAuthToken(token);
    const user = await fetchData();
    if(user)
    {
      const {detail} = user ?? {}
      setUser({
      ...user,
      id: user?._id,
        onboardLastStep: detail?.step ?? null
      });
    }
    return;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setAuthToken(null)
    for (let i = 1; i <= 5; i++) {
      localStorage.removeItem(`step${i}Completed`)
   }
  };

  return (
    <AuthContext.Provider value={{ user, detail, login, logout, setUser, authToken, fetchData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export { AuthProvider, AuthContext };
